import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Gift } from "lucide-react";
import { sharedApi } from "@/lib/api";
import { useAuth } from "@/lib/auth";

/**
 * WO 801c — the welcome bonus (50 + 50 pts) is released only after e-mail
 * AND mobile verification. One-line nudge; hidden when released, nothing
 * when not_eligible.
 */
export default function WelcomeBonusNudge() {
  const { user, token } = useAuth();
  const q = useQuery({
    queryKey: ["welcome-status"],
    enabled: !!(token || user),
    retry: 0,
    staleTime: 60 * 1000,
    queryFn: async () => (await sharedApi.get("/points/welcome-status")).data,
  });
  const d = q.data;
  if (!d || d.state !== "pending") return null;
  const todo = Array.isArray(d.todo) ? d.todo : [];
  const needEmail = todo.includes("verify_email");
  const needMobile = todo.includes("verify_mobile");
  const what = needEmail && needMobile ? "e-mail and mobile" : needEmail ? "e-mail" : "mobile";
  return (
    <div
      data-testid="welcome-bonus-nudge"
      className="rounded-2xl bg-amber-50 border border-amber-200 px-4 py-3 flex flex-wrap items-center gap-x-3 gap-y-2"
    >
      <p className="text-sm font-semibold text-amber-900 flex items-center gap-2">
        <Gift className="w-4 h-4 shrink-0" />
        Verify your {what} to unlock your {Number(d.welcome_bonus) * 2 || 100} welcome points
      </p>
      <span className="flex gap-2 ml-auto">
        {todo.includes("verify_email") && (
          <Link
            to="/account"
            data-testid="welcome-nudge-verify-email"
            className="rounded-full bg-white border border-amber-300 text-amber-800 text-xs font-bold px-3 py-1.5"
          >
            Verify e-mail
          </Link>
        )}
        {todo.includes("verify_mobile") && (
          <Link
            to="/account/add-phone"
            data-testid="welcome-nudge-verify-mobile"
            className="rounded-full bg-white border border-amber-300 text-amber-800 text-xs font-bold px-3 py-1.5"
          >
            Verify mobile
          </Link>
        )}
      </span>
    </div>
  );
}
